module.exports = __webpack_public_path__ + "img/bluesky3100_09.ab4ef8ba.jpg";